const getPageCount = (count, pageSize) => Math.ceil(count / pageSize);

export default { getPageCount };



// WEBPACK FOOTER //
// ./src/components/pagination/pagination.helper..js